import React from 'react'

import ManualApplication from './drawer'
import { setManualApplicationDrawerStep } from '@/client/generalSlice'
import { setManualApplicationDrawerOpen } from '@/client/generalSlice'
import { useAppDispatch, useAppSelector } from '@/client/hooks'
import { Drawer } from '@/components/Drawer/DrawerV2'

export function ManualApplicationDrawer() {
  const dispatch = useAppDispatch()

  const isOpen = useAppSelector((state) => state.general.manualApplicationDrawerOpen)

  return (
    <Drawer
      title='Workflow / Manually Create Opportunity'
      isOpen={isOpen}
      setIsOpen={(isOpen) => {
        dispatch(setManualApplicationDrawerStep(0))
        dispatch(setManualApplicationDrawerOpen(isOpen))
      }}
    >
      <ManualApplication />
    </Drawer>
  )
}
